import React, { Component } from 'react';
import common from 'ui-react-common';

const Select = common.ui.components.forms.Select;

export const validation = {
    validateOn: ['blur'],
    required: true,
    message: {
        default: 'Please select an option',
    },
};

export const homeOwnershipTypes = [
    { text: 'Rent', value: 'rent' },
    { text: 'Mortgage', value: 'mortgage' },
    { text: 'Own', value: 'own' }
];

class HomeOwnership extends Component {
    render() {
        return (
            <Select
                id="homeOwnership"
                name="homeOwnership"
                type="text"
                placeholder="Rent or own?"
                options={homeOwnershipTypes}
                validation={validation}
                value={this.props.value}
                usePlaceholderOption
            />
        );
    }
}

export default HomeOwnership;
